import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-slate-900 text-white pt-8 pb-10">
            <div className="section-padding">
                <div className="grid md:grid-cols-4 gap-12 mb-10">
                    <div className="col-span-2 md:col-span-1">
                        <div className="flex items-center gap-2 mb-6 text-white">
                            <div className="w-8 h-8 bg-gradient-to-br from-indigo-600 to-sky-500 rounded-lg flex items-center justify-center font-bold shadow-lg shadow-indigo-500/20">O</div>
                            <span className="text-xl font-bold">OmniTrace<span className="text-sky-500">X</span></span>
                        </div>
                        <p className="text-slate-400 mb-6 max-w-xs">
                            Next-generation ERP providing absolute traceability for modern manufacturing companies.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6">Product</h4>
                        <ul className="space-y-4 text-slate-400">
                            <li><a href="#features" className="hover:text-sky-400 transition-colors">Features</a></li>
                            <li><a href="#traceability" className="hover:text-sky-400 transition-colors">Traceability</a></li>
                            <li><a href="#pricing" className="hover:text-sky-400 transition-colors">Pricing</a></li>
                            <li><a href="#" className="hover:text-sky-400 transition-colors">Integrations</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6">Company</h4>
                        <ul className="space-y-4 text-slate-400">
                            <li><a href="#" className="hover:text-sky-400 transition-colors">About Us</a></li>
                            <li><a href="#" className="hover:text-sky-400 transition-colors">Careers</a></li>
                            <li><a href="#" className="hover:text-sky-400 transition-colors">Blog</a></li>
                            <li><a href="#" className="hover:text-sky-400 transition-colors">Contact</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold mb-6">Legal</h4>
                        <ul className="space-y-4 text-slate-400">
                            <li><a href="#" className="hover:text-sky-400 transition-colors">Privacy Policy</a></li>
                            <li><a href="#" className="hover:text-sky-400 transition-colors">Terms of Service</a></li>
                            <li><a href="#" className="hover:text-sky-400 transition-colors">Cookie Policy</a></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-slate-800 pt-10 flex flex-col md:flex-row justify-between items-center gap-6">
                    <p className="text-slate-500 text-sm">
                        © 2026 OmniTrace Systems. All rights reserved.
                    </p>
                    <div className="flex gap-6">
                        {['Twitter', 'LinkedIn', 'Github'].map((social, i) => (
                            <a key={i} href="#" className="text-slate-500 hover:text-white transition-colors text-sm font-medium">
                                {social}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
